import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { FlashCardManagementService } from 'src/app/Services/flashcard-management.service';
import { ConstantVars } from 'src/app/utils/constants/constants';

export interface IStudyUnitDisplayOrder {
  Study_Unit_Id: number;
  Path_Name: string;
  Study_Unit_Name: string;
  Study_Unit_Status_Type_Code: string;
  Study_unit_Display_Order: number;
  Major_Topic_ID: number;
  Major_Topic_Name: string;
  Major_Topic_Sort_Order: number;
}

@Component({
  selector: 'app-study-unit-display-order',
  templateUrl: './study-unit-display-order.component.html',
  styleUrls: ['./study-unit-display-order.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class StudyUnitDisplayOrderComponent implements OnInit {
  @Input() SubjectId!: number;
  @Input() courseId!: number;

  path = '';
groupedStudyUnits: {
  majorTopicId: number;
  majorTopicName: string;
  majorTopicSortOrder: number;
  formArray: FormArray;
}[] = [];


  @ViewChild('scrollArea', { static: true })
  scrollArea!: ElementRef<HTMLElement>;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private service: ContentManagementService,
    private toastr: ToastrService,
    private flashcardService: FlashCardManagementService
  ) {}

  ngOnInit(): void {
    this.loadPath();
    this.getStudyUnitSubject();
  }

  loadPath() {
    const payload = {
      SubjectId: this.SubjectId,
      ScreenName: 'CONTENT_MANAGEMENT',
    };

    this.flashcardService
      .getPath$(payload)
      .pipe(catchError(() => of('')))
      .subscribe((res) => (this.path = res));
  }

  getStudyUnitSubject() {
    const payload = {
      Subject_ID: +this.SubjectId,
      Course_Id: +this.courseId,
    };

    this.service.getStudyUnitsDisplayOrder(payload).subscribe((res) => {
      if (!Array.isArray(res)) return;

      const groupMap = new Map<number, IStudyUnitDisplayOrder[]>();

      res.forEach((item) => {
        if (!groupMap.has(item.Major_Topic_ID)) {
          groupMap.set(item.Major_Topic_ID, []);
        }
        groupMap.get(item.Major_Topic_ID)!.push(item);
      });

      this.groupedStudyUnits = [];

      groupMap.forEach((items, majorTopicId) => {
        const sortedItems = [...items].sort(
          (a, b) =>
            (a.Study_unit_Display_Order ?? 0) -
            (b.Study_unit_Display_Order ?? 0)
        );

        const formArray = this.fb.array(
          sortedItems.map((e) => this.createFormGroup(e))
        );

        this.groupedStudyUnits.push({
          majorTopicId,
          majorTopicName: sortedItems[0].Major_Topic_Name,
          majorTopicSortOrder: sortedItems[0].Major_Topic_Sort_Order,
          formArray,
        });
      });

      // ✅ SORT GROUPS
      this.groupedStudyUnits.sort(
        (a, b) => a.majorTopicSortOrder - b.majorTopicSortOrder
      );
    });
  }

  createFormGroup(value: IStudyUnitDisplayOrder): FormGroup {
    return this.fb.group({
      studyUnitId: [{ value: value.Study_Unit_Id, disabled: true }],
      studyUnitName: [{ value: value.Study_Unit_Name, disabled: true }],
      topic: [{ value: value.Path_Name, disabled: true }],
      studyUnitStatus: [
        { value: value.Study_Unit_Status_Type_Code, disabled: true },
      ],
      displayOrder: [
        { value: value.Study_unit_Display_Order, disabled: true },
      ],
    });
  }

  drop(event: CdkDragDrop<FormArray>, formArray: FormArray) {
    moveItemInArray(
      formArray.controls,
      event.previousIndex,
      event.currentIndex
    );

    formArray.controls.forEach((control, index) => {
      control.get('displayOrder')?.setValue(index + 1);
    });
  }

  onSave() {
    const payloadArray = this.groupedStudyUnits.reduce((acc, group) => [
      ...acc,
      ...group.formArray.value.map((e: any) => ({
        StudyUnitID: e.studyUnitId,
        DisplayOrder: e.displayOrder,
      }))
    ], [] as any[]);

    const payload = {
      UDTStudyUnitDisplayOrder: payloadArray,
      Course_Id: +this.courseId,
    };

    this.service.updateStudyUnitDisplayOrder(payload).subscribe(
      () =>
        this.toastr.success(
          'Display Order Saved',
          '',
          { timeOut: ConstantVars.ToastSucessTimeout }
        ),
      () =>
        this.toastr.error(
          'Something went wrong',
          '',
          { timeOut: ConstantVars.ToastErrorTimeout }
        )
    );
  }

  onCross() {
    this.activeModal.close(false);
  }
}
